
const state = () => ({
  serviceList: ["hand", "foot", "gel", "facial"], 
  serviceTypes: ["nail", "face"], 
  services: {
    "hand": {
      name: "hand", 
      type: "nail"
    }, 
    "foot": {
      name: "foot", 
      type: "nail"
    }, 
    "gel": {
      name: "gel", 
      type: "nail"
    }, 
    "facial": {
      name: "facial", 
      type: "face"
    }, 
  }
})

const getters = {
  getServicesOfType: (state) => (servicetype) => {
    let servicelist = [];
    for (let id in state.services){
      if (state.services[id].type === servicetype){
        servicelist.push(state.services[id]);
      }
    }
    return servicelist;
  }, 
}

export default{
  namespaced: true, 
  state, 
  getters, 
}

